/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPricingsIndividualHealthGranteesQuery = gql`
  query GetSimulationPricingsIndividualHealthGranteesQuery {
    getSimulationPricingsIndividualHealthGrantees_simulation_pricings_individual_health {
      beneficiaries {
 type  
birthDate  
beneficiaryId  
index  
firstName  
lastName  
socialSecurities {
 regime  
} 
}
    }
  }
`;

export default GetSimulationPricingsIndividualHealthGranteesQuery;
